<template>
    <div class="code-editor">
        <resize-observer @notify="handleResize" />
        <Toolbar :id="id" :executionState="executionState" :inspector-visible="inspectorVisible" :screen-visible="screenVisible" :hasPredefinedEntries="predefinedEntries !== ''" ></Toolbar>
        <Split v-bind:style="{ height: containerHeight + 'px' }" :gutterSize="10" ref="inspectorSplit">
            <SplitArea :size="horizontalSplit.hLeft">
                <Split v-bind:style="{ height: (containerHeight - 2) + 'px' }" direction="vertical" :gutterSize="10"  ref="screenSplit">
                    <SplitArea class="box" :size="verticalSplit.vTop">
                        <div class="title">
                            C&oacute;digo {{ customLanguage ? '(Lenguage personalizado)' : '' }}
                            <div class="window-button" v-on:click="emitEvent('editor.fontSizeDown')">-</div>
                            <div class="window-button" v-on:click="emitEvent('editor.fontSizeUp')">+</div>
                        </div>
                        <codemirror :readOnly="executionState.running" v-bind:style="{'font-size': preferences.fontCodeSize + 'px', 'font-weight': preferences.fontCodeBold ? 'bold' : 'normal', 'font-style': preferences.fontCodeItalic ? 'italic' : 'normal'}" ref="editor" class="code" v-model="code" :options="cmOption"></codemirror>
                    </SplitArea>
                    <SplitArea class="box screenRef" :size="verticalSplit.vBottom">
                        <div class="window-wrapper" v-bind:class="{'fullscreen': screenFullscreen}">
                            <div class="title">
                                Pantalla
                                <div class="window-button" v-on:click="toggleScreen()">X</div>
                                <div class="window-button" v-on:click="emitEvent('screen.fontSizeDown')">-</div>
                                <div class="window-button" v-on:click="emitEvent('screen.fontSizeUp')">+</div>
                                <div class="window-button" v-bind:class="{'window-button-raised': screenFullscreen}" v-on:click="toggleScreenFullscreen()">Pantalla Completa</div>
                            </div>
                            <Screen v-on:read="execReadComplete" :read-input-mode="executionState.readInputMode" :lines="screenLines" ref="screen"></Screen>
                        </div>
                    </SplitArea>
                </Split>
            </SplitArea>
            <SplitArea class="box inspector" :size="horizontalSplit.hRight"  >
                <div class="title">
                    Inspector
                    <div class="window-button" v-on:click="toggleInspector()">X</div>
                </div>
                <Inspector :id="id" :inspections="inspections" :outline="outline"></Inspector>
            </SplitArea>
        </Split>
        <div class="my-modal" v-show="showModal">
            <div class="wrapper">
                <div class="title">
                    Predefinir Entrada
                </div>
                <div class="body">
                    Escriba a continuación la entrada que será ingresada automáticamente. Escriba un elemento por linea.
                    <textarea v-model="newPredefinedEntries" name="input" id="" rows="20"></textarea>
                </div>
                <div class="footer">
                    <PsButton :model="'Cancelar'" :icon="'fa-times'" :icon-color="'fa-red'" @click="showModal = false"></PsButton>
                    <PsButton :model="'Aceptar'" :icon="'fa-check'" :icon-color="'fa-green'" @click="savePredefinedEntries"></PsButton>
                </div>
            </div>
        </div>
        <MachineInspector v-show="showMachineInspector" :id="id"></MachineInspector>
    </div>
</template>
<script>
    import { EventBus } from './../../EventBus.js'
    import { Storage } from './../../Storage.js'

    import Parser from '../../Core/Parser/Parser'
    import VirtualMachine from '../../Core/VirtualMachine/VirtualMachine'
    import PsButton from './../Widget/PsButton'

    import Screen from './Screen'
    import Toolbar from './Toolbar'
    import Inspector from './Inspector'
    import MachineInspector from './MachineInspector'

    import VueSplit from 'vue-split-panel'

    import 'vue-resize/dist/vue-resize.css'
    import { ResizeObserver } from 'vue-resize'

    import { codemirror } from 'vue-codemirror'
    import 'codemirror/lib/codemirror.css'
    import 'codemirror/addon/lint/lint.css'
    import 'codemirror/addon/hint/show-hint.css'
    import 'codemirror/addon/display/autorefresh.js'
    import 'codemirror/addon/mode/simple.js'
    import 'codemirror/addon/lint/lint.js'
    import 'codemirror/addon/hint/show-hint.js'
    import 'codemirror/addon/selection/mark-selection.js'
    import 'codemirror/addon/search/searchcursor.js'
    import 'codemirror/addon/search/match-highlighter.js'
    import 'codemirror/addon/selection/active-line.js'

    import CodeMirror from 'codemirror'

    import './../../Codemirror/mode'
    import './../../Codemirror/lint'
    import './../../Codemirror/hint'
    import './../../Codemirror/autocomplete'

    export default {
        name: 'TabCodeEditor',
        props: ['id'],
        components: {
            Split: VueSplit.Split,
            SplitArea: VueSplit.SplitArea,
            codemirror,
            Screen,
            Toolbar,
            ResizeObserver,
            PsButton,
            Inspector,
            MachineInspector
        },
        computed: {
            codemirror () {
                return this.$refs.editor.codemirror
            }
        },
        created () {
            window.vms[this.id] = new VirtualMachine()
            this.customLanguage = window.LangConfig.isCustomLanguage()
            this.updatePreferences()
        },
        mounted () {
            let data = Storage.getTabData(this.id)
            if (data !== null) {
                this.code = data.code || ''
                this.predefinedEntries = data.predefinedEntries || ''
                this.screenLines = data.screenLines || []
                if (data.screenVisible !== undefined && this.screenVisible !== data.screenVisible) {
                    this.toggleScreen()
                }
                if (data.inspectorVisible !== undefined && this.inspectorVisible !== data.inspectorVisible) {
                    this.toggleInspector()
                }
                if (data.inspections !== undefined) {
                    this.inspections = data.inspections
                    this.updateInspections()
                }
                if (data.breakpoints && Array.isArray(data.breakpoints)) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            for (let breakpoint of data.breakpoints) {
                                this.addEditorGutter(breakpoint)
                            }
                        }, 0)
                    })
                }
            }

            this.registerEventHandlers()

            Storage.onTabRemove(id => {
                delete window.vms[id]
            })

            let split = this.$refs.inspectorSplit.$el
            split.querySelector('.gutter.gutter-horizontal').style.display = 'none'
            split.querySelector('.split.split-horizontal.inspector').style.display = 'none'

            this.containerHeight = this.$el.parentElement.clientHeight - 60

            this.codemirror.on('keyup', function (cm, event) {
                /* Enables keyboard navigation in autocomplete list */
                /* Enter - do not open autocomplete list just after item has been selected in it */

                // Enter, backspace and arrows
                let bannedKeys = [13, 37, 38, 39, 40, 8]

                if (!cm.state.completionActive && !bannedKeys.includes(event.keyCode)) {
                    CodeMirror.commands.autocomplete(cm, null, {completeSingle: false, keyCode: event.keyCode})
                }
            })
            this.codemirror.on('keydown', function (cm, event) {
                if (event.keyCode === 13) {
                    CodeMirror.commands.psflexAutocomplete(cm, event)
                }
            })
            this.codemirror.on('processNameChange', (data) => {
                this.title = data.name
                Storage.updateTabTitle(this.id, this.title)
            })
            this.codemirror.on('gutterClick', this.editorGutterClick)
        },
        watch: {
            screenLines () {
                this.saveToStorage()
            },
            screenVisible () {
                this.saveToStorage()
            },
            inspectorVisible () {
                this.saveToStorage()
            },
            code () {
                this.saveToStorage()
                this.updateOutline()
                this.updateInspections()
            },
            inspections () {
                this.saveToStorage()
            },
            'executionState.running' (newValue) {
                this.cmOption.readOnly = newValue
            }
        },
        methods: {
            emitEvent (name) {
                EventBus.$emit(name)
            },
            saveToStorage () {
                let breakpoints = this.getBreakpoints()
                let data = {
                    code: this.code,
                    predefinedEntries: this.predefinedEntries,
                    screenLines: this.screenLines,
                    screenVisible: this.screenVisible,
                    inspectorVisible: this.inspectorVisible,
                    inspections: this.inspections,
                    breakpoints: breakpoints
                }
                Storage.updateTabData(this.id, data)
            },
            registerEventHandlers () {
                EventBus.$on('editor.downloadCode.' + this.id, this.downloadCode)
                EventBus.$on('editor.downloadScreen.' + this.id, this.downloadScreen)
                EventBus.$on('editor.execute.' + this.id, this.execute)
                EventBus.$on('editor.stopExecution.' + this.id, this.execStop)
                EventBus.$on('screen.toggle.' + this.id, this.toggleScreen)
                EventBus.$on('screen.clear.' + this.id, this.clearScreen)
                EventBus.$on('screen.fullscreen.' + this.id, this.toggleScreenFullscreen)
                EventBus.$on('inspector.toggle.' + this.id, this.toggleInspector)
                EventBus.$on('inspector.new.add.' + this.id, this.addNewInspection)
                EventBus.$on('inspector.remove.' + this.id, this.removeInspection)
                EventBus.$on('inspector.remove.all.' + this.id, this.removeAllInspections)
                EventBus.$on('predefined.show.' + this.id, this.showPredefinedEntriesModal)
                EventBus.$on('vm.inspector.toggle.' + this.id, this.toggleMachineInspector)
                EventBus.$on('config.preferences.changed', this.updatePreferences)
            },
            updatePreferences () {
                for (let prefName in this.preferences) {
                    this.preferences[prefName] = Storage.getPreference(prefName, this.preferences[prefName])
                }
                window.changeCodeMirrorFont(this.preferences.fontCodeName)
            },
            downloadScreen () {
                let screen = ''
                for (let line of this.screenLines) {
                    if (line !== '') {
                        screen += line + '\r\n'
                    }
                }
                if (screen !== '') {
                    this.downloadFile(this.title + '-Pantalla.txt', screen)
                } else {
                    alert('No hay nada en la pantalla para guardar.')
                }
            },
            toggleScreenFullscreen () {
                this.screenFullscreen = !this.screenFullscreen
            },
            clearScreen () {
                this.screenLines = []
            },
            downloadCode () {
                this.downloadFile(this.title + '.psf', this.code.replace(/\n/g, '\r\n'))
            },
            downloadFile (title, content) {
                function destroyClickedElement (event) {
                    document.body.removeChild(event.target)
                }
                window.URL = window.URL || window.webkitURL
                let textFileAsBlob = new Blob([content], { type: 'text/plain' })
                let downloadLink = document.createElement('a')
                downloadLink.download = title
                downloadLink.innerHTML = 'download link'
                downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
                downloadLink.onclick = destroyClickedElement
                downloadLink.style.display = 'none'
                document.body.appendChild(downloadLink)
                downloadLink.click()
            },
            toggleInspector () {
                let split = this.$refs.inspectorSplit.$el
                if (this.inspectorVisible) {
                    this.horizontalSplit.hLeft = 100
                    this.horizontalSplit.hRight = 0
                    this.$nextTick(() => {
                        setTimeout(() => {
                            split.querySelector('.gutter.gutter-horizontal').style.display = 'none'
                            split.querySelector('.split.split-horizontal.inspector').style.display = 'none'
                        }, 0)
                    })
                } else {
                    this.horizontalSplit.hLeft = 60
                    this.horizontalSplit.hRight = 40
                    this.$nextTick(() => {
                        setTimeout(() => {
                            split.querySelector('.gutter.gutter-horizontal').style.display = ''
                            split.querySelector('.split.split-horizontal.inspector').style.display = ''
                        }, 0)
                    })
                }
                this.inspectorVisible = !this.inspectorVisible
            },
            toggleScreen () {
                let split = this.$refs.screenSplit.$el
                if (this.screenVisible) {
                    this.verticalSplit.vTop = 100
                    this.verticalSplit.vBottom = 0
                    this.$nextTick(() => {
                        setTimeout(() => {
                            split.querySelector('.gutter.gutter-vertical').style.display = 'none'
                            split.querySelector('.split.split-vertical.screenRef').style.display = 'none'
                        }, 0)
                    })
                } else {
                    this.verticalSplit.vTop = 60
                    this.verticalSplit.vBottom = 40
                    this.$nextTick(() => {
                        setTimeout(() => {
                            split.querySelector('.gutter.gutter-vertical').style.display = ''
                            split.querySelector('.split.split-vertical.screenRef').style.display = ''
                        }, 0)
                    })
                }
                this.screenVisible = !this.screenVisible
            },
            savePredefinedEntries () {
                this.predefinedEntries = this.newPredefinedEntries
                this.showModal = false
            },
            showPredefinedEntriesModal () {
                this.newPredefinedEntries = this.predefinedEntries
                this.showModal = true
            },
            getBreakpoints () {
                let breakpoints = []
                for (let i = 0; i < this.codemirror.lineCount(); i++) {
                    if (this.lineHasBreakpoint(i)) {
                        breakpoints.push(i)
                    }
                }
                return breakpoints
            },
            lineHasBreakpoint (lineNum) {
                let lineInfo = this.codemirror.lineInfo(lineNum)
                return lineInfo !== null && lineInfo.gutterMarkers !== undefined && lineInfo.gutterMarkers !== null
            },
            addEditorGutter (lineNum) {
                if (lineNum < 0 || lineNum >= this.codemirror.lineCount()) {
                    return
                }
                let marker = document.createElement('div')
                marker.style.color = '#B44'
                marker.innerHTML = '●'
                this.codemirror.setGutterMarker(lineNum, 'breakpoints', marker)
            },
            editorGutterClick (codemirror, lineNum) {
                if (lineNum < 0 || lineNum >= this.codemirror.lineCount()) {
                    return
                }
                if (this.lineHasBreakpoint(lineNum)) {
                    this.codemirror.setGutterMarker(lineNum, 'breakpoints', null)
                } else {
                    let marker = document.createElement('div')
                    marker.style.color = '#B44'
                    marker.innerHTML = '●'
                    this.codemirror.setGutterMarker(lineNum, 'breakpoints', marker)
                }
                this.saveToStorage()
            },
            handleResize () {
                this.containerHeight = this.$el.parentElement.clientHeight - 60
            },
            markLine (lineNro) {
                try {
                    if (this.markedLine !== null) {
                        this.markedLine.clear()
                    }
                    this.markedLine = this.$refs.editor.codemirror.markText({line: lineNro, ch: 0}, {line: lineNro, ch: 9999}, {className: 'cm-selected-text'})
                    let t = this.$refs.editor.codemirror.charCoords({line: lineNro, ch: 0}, 'local').top
                    let middleHeight = this.$refs.editor.codemirror.getScrollerElement().offsetHeight / 2
                    this.$refs.editor.codemirror.scrollTo(null, t - middleHeight - 5)
                } catch (e) {}
            },
            execStop () {
                this.executionState.running = false
                this.screenLines.push('Ejecución detenida.')
                if (this.markedLine !== null) {
                    this.markedLine.clear()
                }
                this.executionState.readInputMode = 'none'
                this.executionState.running = false
                this.executionState.paused = false
                this.executionState.onBreakpoint = false
            },
            toggleMachineInspector () {
                if (this.showMachineInspector === true) {
                    this.showMachineInspector = false
                    return
                }
                let parser = new Parser({
                    config: window.LangConfig
                })

                let program = parser.parse(this.code)
                if (program === false) {
                    this.screenLines = ['El código contiene errores. Corrija los errores y vuelva a intentarlo.']
                } else {
                    window.vms[this.id].setProgram(program)
                    this.showMachineInspector = true
                }
            },
            addNewInspection (context, expression) {
                let id = Storage.uniqueid()
                if (this.inspections[context] === undefined) {
                    this.inspections[context] = {}
                }
                for (let ins in this.inspections[context]) {
                    if (this.inspections[context][ins].expression === expression) {
                        return
                    }
                }
                this.inspections[context][id] = {
                    isValid: false,
                    errors: [],
                    type: null,
                    expression,
                    id
                }
                this.updateInspections()
            },
            removeInspection (id) {
                for (let context in this.inspections) {
                    if (this.inspections[context][id] !== undefined) {
                        delete this.inspections[context][id]
                        if (Object.keys(this.inspections[context]).length === 0) {
                            delete this.inspections[context]
                        }
                        break
                    }
                }

                this.updateInspections()
            },
            removeAllInspections () {
                this.inspections = {}
                this.updateInspections()
            },
            updateOutline () {
                let that = this
                let parser = new Parser({
                    config: window.LangConfig,
                    outlineCb: function (outline) {
                        that.outline = outline
                    }
                })
                parser.parse(this.code)
            },
            updateInspections () {
                let that = this
                let parser = new Parser({
                    config: window.LangConfig,
                    inspections: this.inspections,
                    inspectionSuccessCb: function (context, id, type) {
                        that.inspections[context][id].isValid = true
                        that.inspections[context][id].type = type
                    },
                    inspectionErrorCb: function (context, id, type, error) {
                        that.inspections[context][id].isValid = false
                        that.inspections[context][id].type = type
                        that.inspections[context][id].errors.push(error)
                    }
                })
                for (let context in this.inspections) {
                    for (let id in this.inspections[context]) {
                        this.inspections[context][id].isValid = false
                        this.inspections[context][id].errors = []
                    }
                }
                parser.parse(this.code)
                this.saveToStorage()
                EventBus.$emit('inspector.updated.' + this.id)
            },
            resumeExecution () {
                let that = this
                this.executionState.onBreakpoint = false
                this.executionState.paused = false
                this.$nextTick(() => {
                    setTimeout(() => {
                        that.continueExecution()
                    }, 0)
                })
            },
            newExecution () {
                let that = this
                let parser = new Parser({
                    config: window.LangConfig,
                    inspections: this.inspections
                })

                if (!this.screenVisible) {
                    this.toggleScreen()
                }

                if (this.code.trim() === '') {
                    this.screenLines = ['Antes de ejecutar debe escribir código.']
                    return
                }

                let program = parser.parse(this.code)
                if (program === false) {
                    this.screenLines = ['El código contiene errores. Corrija los errores y vuelva a intentarlo.']
                } else {
                    EventBus.$emit('inspector.clear.' + this.id)
                    this.executionState.running = true
                    this.executionState.paused = false
                    this.executionState.onBreakpoint = false
                    this.screenLines = ['Ejecutando...', '']
                    if (this.predefinedEntries !== '') {
                        this.predefinedEntriesToExec = this.predefinedEntries.split('\n')
                    }

                    window.vms[this.id].setProgram(program)

                    this.$nextTick(() => {
                        setTimeout(() => {
                            that.continueExecution()
                        }, 0)
                    })
                }
            },
            execute (nextAction) {
                this.executionState.nextAction = nextAction

                if (this.executionState.running) {
                    this.resumeExecution()
                } else {
                    this.newExecution()
                }
            },
            continueExecution () {
                let status
                let that = this
                let shouldReturn = false

                while (this.executionState.running) {
                    status = window.vms[this.id].executeLine()
                    if (status === window.vms[this.id].END_SIGNAL) {
                        this.execEnd(true)
                        return
                    } else if (status === window.vms[this.id].WRITE_SIGNAL) {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.execWrite(window.vms[this.id].getWriteData())
                        this.$nextTick(function () {
                            setTimeout(() => {
                                that.continueExecution()
                            }, 0)
                        })
                        shouldReturn = true
                    } else if (status === window.vms[this.id].CLEAR_SIGNAL) {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.execClearScreen()
                        this.$nextTick(function () {
                            setTimeout(() => {
                                that.continueExecution()
                            }, 0)
                        })
                        shouldReturn = true
                    } else if (status === window.vms[this.id].ERROR_SIGNAL) {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.execError(window.vms[this.id].getLastError())
                        this.execEnd(false)
                        shouldReturn = true
                    } else if (status === window.vms[this.id].READ_SIGNAL) {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.ignoreInput = false
                        if (this.predefinedEntriesToExec.length > 0) {
                            let value = this.predefinedEntriesToExec.shift()
                            this.execWrite(value + '\n')
                            window.vms[this.id].readCompleted(value)
                        } else {
                            this.executionState.readInputMode = 'line'
                            if (this.screenLines[this.screenLines.length - 1] === '') {
                                this.screenLines.pop()
                            }
                            shouldReturn = true
                        }
                    } else if (status === window.vms[this.id].WAIT_KEY_SIGNAL) {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.ignoreInput = true
                        if (this.predefinedEntriesToExec.length > 0) {
                            let value = this.predefinedEntriesToExec.shift()
                            this.execWrite(value + '\n')
                        } else {
                            this.executionState.readInputMode = 'key'
                            if (this.screenLines[this.screenLines.length - 1] === '') {
                                this.screenLines.pop()
                            }
                            shouldReturn = true
                        }
                    } else if (status === window.vms[this.id].WAIT_TIME_SIGNAL) {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.$nextTick(function () {
                            setTimeout(() => {
                                that.continueExecution()
                            }, window.vms[this.id].getWaitValue() * 1000)
                        })
                        shouldReturn = true
                    }
                    if (this.lineHasBreakpoint(window.vms[this.id].getCurrentLine())) {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.executionState.onBreakpoint = true
                        this.executionState.paused = true
                        shouldReturn = true
                    } else if (this.executionState.nextAction === 'toNextLine') {
                        this.markLine(window.vms[this.id].getCurrentLine())
                        this.executionState.paused = true
                        shouldReturn = true
                    }
                    if (shouldReturn) {
                        return
                    }
                }
            },
            execReadComplete (value) {
                if (this.executionState.readInputMode !== 'none') {
                    if (this.executionState.readInputMode === 'line') {
                        this.execWrite('\n' + value + '\n')
                    } else {
                        this.execWrite('\n')
                    }
                    let that = this
                    this.executionState.readInputMode = 'none'
                    if (!this.ignoreInput) {
                        window.vms[this.id].readCompleted(value)
                    }
                    this.$nextTick(() => {
                        setTimeout(() => {
                            that.continueExecution()
                        }, 0)
                    })
                }
            },
            execError (vmError) {
                let message = 'Linea ' + (vmError.getFromLine() + 1) + ':' + (vmError.getFromCol() + 1) + ' - '

                if (vmError.isNullVariable() && !vmError.isArray()) {
                    message += 'La variable <strong>' + vmError.getLexeme() + '</strong> no ha sido inicializada.'
                } else if (vmError.isOutOfRange()) {
                    message += 'El índice <strong>' + vmError.getIndex() + '</strong> esta fuera de los límites del arreglo para <strong>' + vmError.getLexeme() + '</strong>.'
                } else if (vmError.isNullVariable() && vmError.isArray()) {
                    message += 'La variable <strong>' + vmError.getLexeme() + '</strong> no ha sido inicializada en la posición <strong>' + vmError.getIndex() + '</strong>.'
                } else if (vmError.isBooleanRead()) {
                    message += 'El valor introducido no es un valor de tipo Logico.'
                } else {
                    message += 'Error de ejecución. ' + vmError.getMessage()
                }
                // window.vms[this.id]._dumpAll()

                this.execWrite(message + '\n')
            },
            execEnd (clearMarkedLine) {
                if (clearMarkedLine && this.markedLine !== null) {
                    this.markedLine.clear()
                }
                if (this.screenLines[this.screenLines.length - 1] === '') {
                    this.screenLines.pop()
                }
                this.screenLines.push('Fin de la ejecución.')

                this.executionState.running = false
                this.executionState.paused = false
                this.executionState.onBreakpoint = false
            },
            execWrite (value) {
                if (typeof value === 'string') {
                    let lines = value.split('\n')
                    this.screenLines[this.screenLines.length - 1] += lines[0]

                    for (let i = 1; i < lines.length; i++) {
                        this.screenLines.push(lines[i])
                    }
                } else {
                    this.screenLines[this.screenLines.length - 1] += value
                }
            },
            execClearScreen () {
                let screenHeight = this.$refs.screen.$el.clientHeight
                let linesToAdd = Math.ceil(screenHeight !== undefined ? screenHeight / this.preferences.fontScreenSize + 2 : 20)
                for (let i = 0; i < linesToAdd; i++) {
                    this.screenLines.push('')
                }
            }
        },
        data () {
            return {
                ignoreInput: true,
                screenLines: [],
                containerHeight: 600,
                code: '',
                markedLine: null,
                title: '',
                cmOption: {
                    tabSize: 4,
                    lineNumbers: true,
                    mode: 'psflex',
                    gutters: ['CodeMirror-lint-markers', 'mark-selection', 'breakpoints'],
                    lint: true,
                    styleSelectedText: true,
                    styleActiveLine: true,
                    line: true,
                    autoRefresh: true,
                    readOnly: false
                },
                showModal: false,
                newPredefinedEntries: '',
                predefinedEntries: '',
                predefinedEntriesToExec: [],
                inspectorVisible: false,
                horizontalSplit: {
                    hLeft: 100,
                    hRight: 0
                },
                verticalSplit: {
                    vTop: 60,
                    vBottom: 40
                },
                screenVisible: true,
                screenFullscreen: false,
                preferences: {
                    fontCodeName: 'Inconsolata',
                    fontCodeSize: 12,
                    fontCodeBold: false,
                    fontCodeItalic: false,
                    fontScreenSize: 16
                },
                customLanguage: false,
                showMachineInspector: false,
                outline: {},
                inspections: {},
                executionState: {
                    readInputMode: 'none',
                    running: false,
                    paused: false,
                    nextAction: 'normal',
                    onBreakpoint: false
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .my-modal {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background: rgba(0.5,0.5,0.5, 0.4);
        z-index: 1000;
        text-align: center;
    }

    .my-modal .wrapper {
        display: inline-block;
        border: 1px solid #555;
        box-shadow: 0px 0px 12px rgba(0.5, 0.5, 0.5, 0.3);
        padding: 0px;
        margin-top: 100px;
        background: #FFF;
        text-align: left;
        max-width: 600px;

    }
    .my-modal .title {
        margin-bottom: 10px;
        padding-left: 4px;
        padding-right: 4px;
        padding-bottom: 6px;
        padding-top: 2px;
        background-color: #D0D9E9;
        font-size: 12px;
        height: 15px;
        overflow: hidden;
        border-bottom: 1px solid #A0A9C9;
    }
    .my-modal .body {
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .my-modal .footer {
        text-align: right;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .my-modal textarea {
        width: 100%;
        border: 1px solid #AAA;
        margin-top: 6px;
        padding: 0px;
    }


    .cm-selected-text {
        background: #EEA !important;
    }
    .code-editor {
        margin: 10px;
    }
    .vue-codemirror {
        height: calc(100% - 25px) !important;
    }
    .CodeMirror {
        height: 100% !important;
    }
    .box {
        border: 1px solid #999;
    }

    .title {
        padding-left: 4px;
        padding-right: 4px;
        padding-bottom: 6px;
        padding-top: 2px;
        background-color: #D0D9E9;
        font-size: 12px;
        height: 15px;
        overflow: hidden;
        border-bottom: 1px solid #A0A9C9;
    }

    .title div {
        display: inline-block;
        float: right;
        border: 1px solid #888;
        background: #EEE;
        margin-left: 10px;
        min-width: 10px;
        text-align: center;
        line-height: 14px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 2px;
        padding-bottom: 2px;
        cursor: default;
        color: #333;
    }

    .title div:hover {
        cursor: pointer;
        background: #CCC;
    }

    .window-wrapper {
        width: 100%;
        height:  100%;
    }

    .window-wrapper.fullscreen {
        position: absolute;
        top: 50px;
        bottom: 10px;
        right: 10px;
        left: 10px;
        z-index: 1000;
        height: calc(100% - 60px);
        width: calc(100% - 20px);
        border: 1px solid #999;
    }
    .window-button-raised {
        border: 1px solid #999;
        background: #B8B8B8 !important;
    }
</style>


// WEBPACK FOOTER //
// src/Components/CodeEditor/CodeEditor.vue